import { api } from "@/api";

/**
 * The customer's PIN. Logged in the booking's history on the server. Deliberately not a query: the
 * query cache is persisted to sessionStorage, so the PIN lives only in the
 * component that asked for it.
 */
export const revealStoragePin = async (bookingId: string) => {
  const { body } = await api.post<{ pin: string }>(
    `/storage/bookings/${bookingId}/pin/reveal`,
  );
  return body.pin;
};
